import { render, staticRenderFns } from "./LkTableBodyCell.vue?vue&type=template&id=5b689dd1&"
import script from "./LkTableBodyCell.vue?vue&type=script&lang=js&"
export * from "./LkTableBodyCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports